import { render } from "./MarketingVideo.vue?vue&type=template&id=1c0cc3f6&ts=true"
import script from "./MarketingVideo.ts?vue&type=script&lang=ts&external"
export * from "./MarketingVideo.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__